

















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Route } from 'vue-router'
import store from '@/store'
import { createOnlineStatusConnection } from '@/websocket/utils/onlineStatus'
import { createECGConnection } from '@/websocket/utils/ECG'
import { watchVitalsign } from '@/ble/vitalsignWatcher'
import WebRTCProvider from '@/webrtc'

@Component({
  components: {
    AppHeader: () => import('@/components/patient/Header.vue'),
    MessageReceiveModal: () =>
      import('@/components/common/MessageReceiveModal.vue'),
    AlertModal: () => import('@/components/common/AlertModal.vue'),
    VideoCallIncomingContainer: () =>
      import('@/components/common/videoCallRoom/VideoCallIncomingContainer.vue')
  }
})
export default class Base extends Vue {
  $store!: ExStore

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get videoRoomReady() {
    return this.$store.getters['videoCallRoom/videoRoomReady']
  }

  async beforeRouteEnter(to: Route, from: Route, next: any) {
    try {
      await store.dispatch('user/updateUserInfo')
      const user = store.getters['user/userInfo']

      if (user.isWorker) {
        next({ name: 'Home' })
        return
      }

      if (user.isPatientRelative) {
        next({ name: 'RelativeHome' })
        return
      }

      const change = 'InitialPatientPasswordChange'

      if (user.requireChangePassword && to.name !== change) {
        next({ name: change })
        return
      }

      next()
    } catch (e) {
      console.error(e)
      next()
    }
  }

  handleCallAccepted() {
    if (!this.videoRoomReady) {
      this.$router.push({ name: 'PatientCall' })
    }
  }

  beforeCreate() {
    createOnlineStatusConnection()
    createECGConnection()
  }

  created() {
    watchVitalsign(this.userInfo.id)
    this.$store.dispatch('ble/initialize')
    this.attachWindowCloseEvent()
    this.$postMessage.emitVueDidLogin()
  }

  attachWindowCloseEvent() {
    window.addEventListener('unload', () => {
      WebRTCProvider.destroy()
    })
  }
}
